var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardWithTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.0439,
    cy: 64,
    r: 40,
    fill: "#5E5E7F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5677 54.9051L66.908 45.6625C67.5523 45.4639 68.1935 45.7904 68.3801 46.3877L68.38 46.3878L68.3837 46.3988L70.9855 54.0933C71.0739 54.3549 71.3577 54.4953 71.6193 54.4068C71.8809 54.3184 72.0212 54.0346 71.9328 53.773L69.3327 46.0836C68.964 44.9151 67.7282 44.3585 66.6047 44.7096L66.6046 44.7094L66.5937 44.7131L39.2526 53.956C38.084 54.3247 37.5274 55.5605 37.8785 56.6841L37.8784 56.6841L37.8822 56.6954L43.6375 73.6846C44.0063 74.8531 45.2421 75.4096 46.3656 75.0585L46.3656 75.0586L46.3745 75.0556L52.0209 73.1735C52.2829 73.0862 52.4245 72.803 52.3372 72.541C52.2498 72.2791 51.9667 72.1375 51.7047 72.2248L46.0631 74.1053C45.4185 74.3045 44.7769 73.978 44.5901 73.3804L44.5902 73.3803L44.5864 73.3691L38.8314 56.3806C38.6329 55.7364 38.9594 55.0953 39.5567 54.9086L39.5567 54.9088L39.5677 54.9051ZM49.0408 63.233L46.3284 64.1741C45.7748 64.3401 45.1659 64.0634 44.9998 63.5098L44.3355 61.517C44.1694 60.9634 44.4462 60.3545 44.9998 60.1884L47.7123 59.2473C48.2658 59.0813 48.8748 59.358 49.0408 59.9116L49.7051 61.9045C49.8712 62.458 49.5944 63.0669 49.0408 63.233ZM52.3905 66.9959C52.4787 67.2576 52.338 67.5412 52.0763 67.6293L46.9835 69.3454C46.7218 69.4336 46.4382 69.2929 46.35 69.0312C46.2618 68.7695 46.4025 68.4859 46.6642 68.3977L51.757 66.6817C52.0187 66.5935 52.3023 66.7342 52.3905 66.9959ZM56.9453 59.9603C56.9453 59.2954 57.4411 58.7996 58.106 58.7996H87.0022C87.6672 58.7996 88.1629 59.2954 88.1629 59.9603V63.2755H56.9453V59.9603ZM56.9453 67.538H88.1629V77.8959C88.1629 78.5055 87.6118 79.0566 87.0022 79.0566H58.106C57.4411 79.0566 56.9453 78.5608 56.9453 77.8959V67.538ZM58.106 57.7996C56.8888 57.7996 55.9453 58.7431 55.9453 59.9603V77.8959C55.9453 79.1131 56.8888 80.0566 58.106 80.0566H87.0022C88.1641 80.0566 89.1629 79.0577 89.1629 77.8959V59.9603C89.1629 58.7431 88.2195 57.7996 87.0022 57.7996H58.106ZM60.5377 70.6944C60.2615 70.6944 60.0377 70.9182 60.0377 71.1944C60.0377 71.4705 60.2615 71.6944 60.5377 71.6944H75.484C75.7601 71.6944 75.984 71.4705 75.984 71.1944C75.984 70.9182 75.7601 70.6944 75.484 70.6944H60.5377Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2374 66C21.2374 41.354 39.8181 21.4782 63.0439 21.4782V2C29.7536 2 3.04395 30.6211 3.04395 66H21.2374Z",
    fill: "#DD4A2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.0439453,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0933333 0 0 0 0 0.0976 0 0 0 0 0.1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardWithTheme);
export default __webpack_public_path__ + "static/media/credit_card_with_theme.99d96d85.svg";
export { ForwardRef as ReactComponent };